import React from "react"
import { useNavigate } from "react-router-dom"

import Button from "../button/Button"
import { Wrapper, Content, Description, Stack } from "./Card.styles"

const Card = (
  { object } //{ title, description, stack, buttons }
) => {
  const navigate = useNavigate()
  return (
    <Wrapper>
      <Content>
        <Description>
          <h3>{object.title}</h3>
          <Stack>{object.stack}</Stack>
          <p className="justified">{object.description}</p>
          {/* {buttons
          ? buttons.map((button, index) => <Button key={index} text={button} />)
          : null} */}

          {object.case_study ? (
            <Button
              type="button"
              text="Case Study"
              callback={() =>
                navigate(`/project/${object.title}`)
              }
            />
          ) : null}
          {object.read_more ? (
            <Button
              type="button"
              text="Read More"
              callback={() =>
                navigate(`/article/${object.title}`)
              }
            />
          ) : null}

          {object.code ? (
            <Button
              type="button"
              text="Code"
              callback={() => window.open(object.code, "_blank")}
            />
          ) : null}
          {object.link ? (
            <Button
              type="button"
              text="Link"
              callback={() => window.open(object.link, "_blank")}
            />
          ) : null}
        </Description>
      </Content>
    </Wrapper>
  )
}

export default Card
